<h2 mat-dialog-title>Call solicitations - {{ data.expertName }}</h2>
<mat-dialog-content>
  @if (solicitations.isLoading()) {
    <div class="flex justify-center items-center p-8">
      <app-spinner />
    </div>
  } @else if ((solicitations.value() ?? []).length === 0) {
    <app-empty-state title="No call solicitations found for this expert." />
  } @else {
    <table mat-table class="w-full" [dataSource]="solicitations.value() ?? []">
      <ng-container matColumnDef="date">
        <th *matHeaderCellDef mat-header-cell>Date</th>
        <td *matCellDef="let row" mat-cell>
          {{ row.call_datetime | date: 'dd MMM yyyy HH:mm' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="outcome">
        <th *matHeaderCellDef mat-header-cell>Outcome</th>
        <td *matCellDef="let row" mat-cell>
          {{ (row.outcome | callSolicitationOutcome) || 'Pending' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="duration">
        <th *matHeaderCellDef mat-header-cell>Duration</th>
        <td *matCellDef="let row" mat-cell>
          @if (row.duration_seconds !== null) {
            {{ row.duration_seconds }}s
          } @else {
            N/A
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="notes">
        <th *matHeaderCellDef mat-header-cell>Notes</th>
        <td
          *matCellDef="let row"
          mat-cell
          class="max-w-[240px] truncate"
          [matTooltip]="row.notes"
          [matTooltipDisabled]="!row.notes"
        >
          {{ row.notes || '—' }}
        </td>
      </ng-container>

      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
    </table>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
